import { IInventoryPage } from '../../inventory-page.interface';


export const USER_VERIFY_SUCCESS_PAGE: IInventoryPage = {
	'route': '/user/verify-success',
	'title': 'Account Verified',
	'uiReference': [
		"You're ready to fly",
		'Your email address has been verified successfully.',
		'Welcome to Flying',
		'Your account is active. Sign in to continue to your workspace.',
		'Go to sign in',
		'Flying account sign in',
		'Appearance',
		'One secure account for Flying Research and Flying Upload'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/account-verified/account-verified.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/account-verified/account-verified.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.html'
	]
};
